import api from "@/api/axios"; // أو المسار الصح عندك

export default {
  // ===== User =====
  getMyBookings(params = {}) {
    return api.get("/bookings", { params });
  },
  getBooking(id) {
    return api.get(`/bookings/${id}`);
  },
  createBooking(data) {
    return api.post("/bookings", data);
  },
  cancelBooking(id, reason = "") {
    return api.patch(`/bookings/${id}/cancel`, { reason });
  },

  // ===== Owner =====
  getOwnerBookings(params = {}) {
    return api.get("/bookings", { params });
  },
  confirmBooking(id) {
    return api.patch(`/bookings/${id}/confirm`);
  },
  rejectBooking(id, reason) {
    return api.patch(`/bookings/${id}/reject`, { reason });
  },
  completeBooking(id) {
    return api.patch(`/bookings/${id}/complete`);
  },

  // ===== Admin =====
  getAllBookings(params = {}) {
    return api.get("/all-bookings", { params });
  },
  updateBooking(id, data) {
    return api.patch(`/all-bookings/${id}`, data);
  },
  deleteBooking(id) {
    return api.delete(`/all-bookings/${id}`);
  },
  getStats() {
    return api.get("/bookings/stats");
  },
};
